export default function checkLicense(userId: string, assignedLicenses: string[]): boolean {
    return assignedLicenses.includes(userId);
}